import * as React from 'react';
import * as mui from '@material-ui/core';
import * as muis from '@material-ui/core/styles';
import { Route, RouteComponentProps } from 'react-router-dom';

const Recaptcha = require('react-recaptcha');


export class FlexCenterDiv extends React.Component {

    render() {
        return (    
            <div style={{ width: '100%',height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{maxHeight: '100%', overflowY: "auto"}}>
                    
                    {this.props.children}
                </div>
            </div>
            // <mui.Dialog open>
            //     <mui.DialogContent>
            //     {this.props.children}
            //     </mui.DialogContent>
            // </mui.Dialog>
        );
    }
    
}

// var callback = function () {
//     console.log('Recaptcha loaded');
//   };

export class RecaptchaDiv extends React.Component<{verifyCallback: (val:string)=>void}, {scale: number}> {

    recaptcha: any = null;

    keys = {
        'spice3-beta.app.brainhearts-cloud.com': '6LfPM2EUAAAAAK9DnqKYYiYxtghfYukkgrokXSyg',
        'spice3-test.app.brainhearts-cloud.com': '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
        'spice3.app.brainhearts-cloud.com': '6LeCYmEUAAAAAOUdv1gApcGmxm1aJtSnY8ue72_D',
        'timemanager.clouds-spice.com': '6LeCYmEUAAAAAOUdv1gApcGmxm1aJtSnY8ue72_D',
    };


    _getSiteKey() {
        if(window.location.host in this.keys) {
            return this.keys[window.location.host];
        }
        
        // TEST SITE KEY => https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha-v2-what-should-i-do
        return '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; 
    }

    reset() {
        if(this.recaptcha) {
            this.recaptcha.reset();
        }
    }

    componentDidMount() {
        if(this.recaptcha) {
            
        }
    }

    render() {
        return (    
            <div style={{width: '100%'}}>
                <small style={{wordWrap: 'break-word'}}>
                </small>

                <Recaptcha
                    ref={ (o)=>{ this.recaptcha = o; }  }
                    sitekey={this._getSiteKey()} 
                    render="explicit" 
                    verifyCallback={ this.props.verifyCallback }
                    hl="ja"
                    // style={{transform: 'scale'}}
                    // onloadCallback={callback}
                    />
            </div>
        );
    }
    
}

// interface LoginFormComponentParam  {
//     validator: ()=>boolean;
// }
// interface AlertableStepLabelState  {
// }
// export class AlertableStepLabel extends React.Component<LoginFormComponentParam, AlertableStepLabelState> {

//     render() {
//         return (
            
            
//         );
//     }
// }



const buttonStyles = (theme: muis.Theme) => ({
    button: {
        margin: '0.2em',  //   margin: theme.spacing.unit,
    },
  });
type ButtonStylesNames = 'button';

class Button extends React.Component<{
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'primary' | 'secondary' | 'default';
    variant?: 'text' | 'outlined' | 'contained';
    disabled?: boolean;
    onClick?: ()=>void;
}& mui.WithStyles<ButtonStylesNames>> {

    render() {
        return <mui.Button 
            disabled={this.props.disabled}
            className={ this.props.classes.button } 
            onClick={this.props.onClick} 
            variant={this.props.variant|| 'contained'} 
            color={this.props.color}
            size={this.props.size}
            
            > {this.props.children} </mui.Button>;
    }
}


const ButtonHoc = muis.withStyles(buttonStyles)(Button);

interface RoutedButtonProps {
    location: string;
    label: JSX.Element|string;
    icon?: JSX.Element;
    color?: 'inherit' | 'primary' | 'secondary' | 'default';
    style?: any;
    variant?: 'text' | 'outlined' | 'contained';
    onClick?: ()=>void;
    disabled?: boolean;
    size?: 'small' | 'medium' | 'large';
}
export const RoutedButton = (props: RoutedButtonProps) => (
    <Route render={({history}: RouteComponentProps) => (
        <ButtonHoc
            size={props.size}
            color={props.color}
            variant={props.variant }
            disabled={props.disabled}
            onClick={() => { if(props.onClick) {props.onClick();} history.push(props.location); }}
        >
        {props.icon}
        {props.label}
        </ButtonHoc>
    )} />
);

export const RoutedLink = (props: RoutedButtonProps) => (
    

    <Route render={({history}: RouteComponentProps) => (
        <mui.Link 
            component="button"
            onClick={() => { history.push(props.location); } }
            style={props.style}
        >
        {props.icon}
        {props.label}
        </mui.Link>
    )} />
);


interface RoutedListItemProps {
    location: string;
    // label: string;
    // icon?: JSX.Element;
    // color?: 'inherit' | 'primary' | 'secondary' | 'default';
    // variant?: 'flat' | 'raised' | 'fab';
    // onClick?: ()=>void;
    // disabled?: boolean;
    className?: string;
    selected?:boolean;
}

export class RoutedListItem extends React.Component<RoutedListItemProps, {}> {
    render() {
        return <Route render={({history}: RouteComponentProps) => (
            <mui.ListItem button selected={this.props.selected?true:false} className={this.props.className} onClick={ () => {  history.push(this.props.location);  } }>
                {this.props.children}
                
            </mui.ListItem>
        )} />;

    }
}

export const SavingDialog = (p:{open?: boolean}) => <div>
    <mui.Dialog open={p.open ? true : false }>
        <mui.DialogContent>
        
            <mui.CircularProgress size={20}></mui.CircularProgress>
            <mui.DialogContentText> 保存しています</mui.DialogContentText>
        </mui.DialogContent>
    </mui.Dialog>

</div>;